import { render, staticRenderFns } from "./ContactTagsAdmin.vue?vue&type=template&id=cb3a9ad6&scoped=true&"
import script from "./ContactTagsAdmin.vue?vue&type=script&lang=js&"
export * from "./ContactTagsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ContactTagsAdmin.vue?vue&type=style&index=0&id=cb3a9ad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a9ad6",
  null
  
)

export default component.exports